import { useState } from 'react';
import WorkData from './WorkData';
import './Works.css';
import Radio from './Radio';
import RadioGroup from './RadioGroup';

const categories = [...new Set(WorkData.map(work => work.category))];
const years = [...new Set(WorkData.map(work => work.year))].sort().reverse();

const sections = {
  category: categories.map(c => ({ title: c, works: WorkData.filter(work => work.category === c) })),
  year: years.map(y => ({ title: y, works: WorkData.filter(work => work.year === y) })),
};

// "A/B" in a comment is shown as two lines.
function Comment({ text }) {
  const [first, ...rest] = text.split('/');
  return (
    <p>
      {first}
      {rest.length > 0 && <><br/>{rest.join('/')}</>}
    </p>
  );
}

function Works() {
  const [sort, setSort] = useState('category');

  return (
    <div className="Works">
      <RadioGroup label="Sort by" value={sort} onChange={setSort}>
        <Radio name='sort' value='category'>
          <span>CATEGORY</span>
        </Radio>
        <Radio name='sort' value='year'>
          <span>YEAR</span>
        </Radio>
      </RadioGroup>
      <hr/>
      <ul className="Works_section hide-scrollbar">
        {sections[sort].map(section => (
          <li key={section.title}>
            <h1>{section.title}</h1>
            <ul className="Works_in_section">
              {section.works.map(work => (
                <li key={work.name} style={{backgroundImage: `url("/${work.backgroundImage}")`}}>
                  {/* Works without a link yet render an <a> with no href, so nothing opens. */}
                  <a href={work.link || undefined} target="_blank" rel="noreferrer">
                    <div className="Work_header">
                      <h2>{work.name}</h2>
                      <h3>{work.yearDisplay}</h3>
                    </div>
                    <Comment text={work.comment}/>
                  </a>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Works;
